import isArray from "lodash/isArray";
import isObject from "lodash/isObject";
import isString from "lodash/isString";

export default function cleanEmpty(obj) {
  // Only clean plain objects
  if (!isObject(obj) || isArray(obj)) return obj;

  const out = {};

  Object.keys(obj).forEach((key) => {
    const value = obj[key];

    // Remove null/undefined
    if (value == null) return;

    // Remove empty strings (optional; comment out if you want to keep "")
    if (isString(value) && value.trim() === "") return;

    // Recursively clean nested objects
    if (isObject(value) && !isArray(value)) {
      const cleanedChild = cleanEmpty(value);
      if (isObject(cleanedChild) && Object.keys(cleanedChild).length === 0)
        return;
      out[key] = cleanedChild;
      return;
    }

    // Clean arrays: remove empty items; drop array if it ends up empty
    if (isArray(value)) {
      const cleanedArr = value
        .map((item) => {
          if (isObject(item) && !isArray(item)) return cleanEmpty(item);
          return item;
        })
        .filter((item) => {
          if (item == null) return false;
          if (isString(item) && item.trim() === "") return false;
          if (isArray(item)) return item.length > 0;
          if (isObject(item)) return Object.keys(item).length > 0;
          return true;
        });

      if (cleanedArr.length === 0) return;
      out[key] = cleanedArr;
      return;
    }

    // Keep booleans/numbers/non-empty strings/etc.
    out[key] = value;
  });

  return out;
}

// Example:
// const input = {
//   loanDocuments: [],
//   borrowers: undefined,
//   subjectProperties: ["687e3b45138dca9647e7ffb2"],
// };

// console.log(cleanEmpty(input));
// => { subjectProperties: ["687e3b45138dca9647e7ffb2"] }
